import React, { SyntheticEvent } from 'react';
import { Link } from 'react-router';
import ConfirmModal from './confirm-modal';

interface Props {
    danger?: boolean;
    onConfirmedAction: () => void;
    confirmTitle: string;
    confirmMessage: string;
    confirmAction: string;
    rejectAction: string;
    linkClassName?: string;
    children: React.ReactNode;
}

function ConfirmButton(props: Readonly<Props>) {
    const [modalIsOpen, setModalIsOpen] = React.useState(false);

    return (
        <>
            <ConfirmModal
                show={modalIsOpen}
                onConfirm={handleConfirm}
                onClose={handleModalClose}
                confirmTitle={props.confirmTitle}
                confirmMessage={props.confirmMessage}
                confirmAction={props.confirmAction}
                rejectAction={props.rejectAction}
                danger={props.danger}
            />

            <Link
                to={'/'}
                className={props.linkClassName}
                onClick={handleModalOpen}
            >
                {props.children}
            </Link>
        </>
    );

    function handleModalOpen(event: SyntheticEvent) {
        event.preventDefault();
        setModalIsOpen(true);
    }

    function handleModalClose() {
        setModalIsOpen(false);
    }

    function handleConfirm() {
        props.onConfirmedAction();
        setModalIsOpen(false);
    }
}

export default ConfirmButton;
